import { render, staticRenderFns } from "./CustomerAgreement.vue?vue&type=template&id=5838c09a&"
import script from "./CustomerAgreement.vue?vue&type=script&lang=js&"
export * from "./CustomerAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports